/**
 * The admin pages are the platform role's (SB-24, ADR-0006). The API's 403 is the guard; this
 * only says so in words, instead of rendering a page of failed requests. While sign-in is not
 * enforced it changes nothing.
 */
import {ReactNode} from 'react';
import {Box, Typography} from '@mui/material';

import {useAuth} from './AuthContext';

export default function RequireAdmin({children}: {children: ReactNode}) {
    const auth = useAuth();
    if (auth.authEnabled && auth.user && auth.user.role !== 'admin') {
        return (
            <Box sx={{p: 3, maxWidth: 560}}>
                <Typography variant="h5" component="h2">Ingen tilgang</Typography>
                <Typography color="text.secondary" sx={{mt: 1}}>
                    Denne siden er for SuccessBuilder-teamets administratorer.
                </Typography>
            </Box>
        );
    }
    return <>{children}</>;
}
